import { render, staticRenderFns } from "./StallPhotoSlider.vue?vue&type=template&id=aa40455a&scoped=true&"
import script from "./StallPhotoSlider.vue?vue&type=script&lang=js&"
export * from "./StallPhotoSlider.vue?vue&type=script&lang=js&"
import style0 from "./StallPhotoSlider.vue?vue&type=style&index=0&id=aa40455a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa40455a",
  null
  
)

export default component.exports